// Put thy hete on FIGMA
// Point thy finger to thyself's OCD
// For 'i the magic numbers we trust

export const BUY_BAR_STYLE = {
  COLLAPSED_HEIGHT: 77,
  EXPANDED_DEFAULT_HEIGHT: 370,
  EXPANDED_LARGE_HEIGHT: 655,
};

export const BUY_BAR_TABS_STYLE = {
  CONTENT_DEFAULT_HEIGHT: 280,
  CONTENT_LARGE_HEIGHT: 575,
  TABS_DEFAULT_HEIGHT: 60,
  TABS_STICKY_HEIGHT: 44,
};
